import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import Poppins from "assets/fonts/Poppins-Regular.ttf";

export async function pdfAddPageNumbers(pdfBytes: ArrayBuffer) {
  const pdfDoc = await PDFDocument.load(pdfBytes);
  const pages = pdfDoc.getPages();
  pdfDoc.registerFontkit(fontkit);

  let fontToUse: StandardFonts | ArrayBuffer = StandardFonts.Helvetica;

  try {
    const fontResponse = await fetch(Poppins);
    fontToUse = await fontResponse.arrayBuffer();
  } catch (err) {
    console.log("Error loading font", err);
    fontToUse = StandardFonts.Helvetica;
  }

  const font = await pdfDoc.embedFont(fontToUse);

  for (let i = 0; i < pages.length; i++) {
    const page = pages[i];
    const { width } = page.getSize();
    const pageNumber = i + 1;
    page.drawText(
      `Página\u00A0\u00A0${pageNumber}\u00A0/\u00A0${pages.length}`, // \u00A0 -> Código para espaço em branco
      {
        x: width * 0.9 - 24,
        y: 8,
        font,
        size: 8,
        color: rgb(0, 0, 0),
      }
    );
  }

  const modifiedPdfBytes = await pdfDoc.save();
  return modifiedPdfBytes;
}
